import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';


const AllegatiListaTemplate = ({
  items,
  linkTitle,
  linkHref,
  isEditMode,
  showFourColums = false,
  linkText, 
  linkUrl, 
  alignButtonRight,
  cardBackground = 'no-background',
  cardIcon, // Aggiunta dell'icona
  data = {} 
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  // CORREZIONE: Applica flattenToAppURL anche per i link interni
  if (isInternalURL(href)) {
    const flattenedHref = flattenToAppURL(href);
    link = (
      <ConditionalLink to={flattenedHref} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }
  
  // Calcola la larghezza minima in base al numero di colonne
  const minWidth = showFourColums ? '220px' : '280px';

  const iconName = data?.cardIcon || cardIcon; // Prende l'icona dalla configurazione

  // CORREZIONE: Gestione corretta del linkUrl
  const processedLinkUrl = linkUrl && isInternalURL(linkUrl) 
    ? flattenToAppURL(linkUrl) 
    : linkUrl;

  return (
    <div className={`full-width-background-wrapper ${cardBackground}`}>
      
      <div className="simple-card-container">
          {items.map((item) => (
            <div className="list-group-item" key={item['@id']}>
              <div className="card-content card-allegato">
                <ConditionalLink
                  item={item}
                  condition={!isEditMode}
                  style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                >
                  {iconName ? (
                    <i className={`af-icon fa-solid fa-${iconName}`}></i>
                  ) : (<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-link-45deg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
                  </svg>)}
                  
                  {item.title || item.id}                               
                </ConditionalLink>
              </div>
            </div>
          ))}
          
        </div>

        {processedLinkUrl && (
          <div className={`link-button my-4 ${alignButtonRight ? 'align-right' : ''}`}>
            {processedLinkUrl && (
              <div className={`link-button my-4 ${alignButtonRight ? 'align-right' : ''}`}>
                <a
                  href={processedLinkUrl}
                  className={`btn btn-primary`}
                >
                  {linkText || 'Scopri di più'}
                </a>
              </div>
            )}
          </div>
        )}

        {link && <div className="footer">{link}</div>}
      
    </div>
  );
};

AllegatiListaTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default AllegatiListaTemplate;